import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

export type InlineBadgeVariant =
  | 'default'
  | 'warning'
  | 'blue'
  | 'success'
  | 'error';

@Component({
  selector: 'app-inline-badge',
  standalone: true,
  imports: [CommonModule],
  styles: `
    .badge {
      font-family: 'Neue Montreal', sans-serif;
      font-size: 11px;
      font-weight: 500;
      color: var(--gray-600);
      background: var(--gray-100);
      border-radius: 4px;
      padding: 1px 6px;
      line-height: 1.6;
      white-space: nowrap;
    }
    .badge.variant-warning {
      background: #fff7ed;
      border: 1px solid #fed7aa;
      color: #c2410c;
      border-radius: 16px;
      padding: 2px 8px;
    }
    .badge.variant-blue {
      background: #eff6ff;
      border: 1px solid #bfdbfe;
      color: #1d4ed8;
      border-radius: 16px;
      padding: 2px 8px;
    }
    .badge.variant-success {
      background: #f0fdf4;
      border: 1px solid #bbf7d0;
      color: #15803d;
      border-radius: 16px;
      padding: 2px 8px;
    }
    .badge.variant-error {
      background: #fef2f2;
      border: 1px solid #fecaca;
      color: #b91c1c;
      border-radius: 16px;
      padding: 2px 8px;
    }
  `,
  template: `
    <span *ngIf="badgeContent()" [class]="'badge variant-' + variant()">
      {{ badgeContent() }}
    </span>
  `,
})
export class InlineBadgeComponent {
  badgeContent = input.required<string | undefined | null>();

  variant = input<InlineBadgeVariant>('default');
}
